import { render, staticRenderFns } from "./PwaGotoAwardTipsPopup.vue?vue&type=template&id=6dbe0ec6&scoped=true&"
import script from "./PwaGotoAwardTipsPopup.vue?vue&type=script&lang=js&"
export * from "./PwaGotoAwardTipsPopup.vue?vue&type=script&lang=js&"
import style0 from "./PwaGotoAwardTipsPopup.vue?vue&type=style&index=0&id=6dbe0ec6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dbe0ec6",
  null
  
)

export default component.exports